import './index.scss';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Avatar, Button, Tooltip } from '@material-ui/core';
import { NavigationComponent } from './Navigation';
import { NavigationDashboard } from './NavigationDashboard';
import { getUserFullNameInitials, getUserImageLink, translate } from '@utils';
import { LogoMG, LogoutIcon } from '@images/icons';
import { PagePermission, PermissionActions } from '@enums';
import { MgState } from '@types';
import { currentUserSelector } from '@selectors/user';
import { AuthPaths, Paths } from '@constants/paths';
import cx from 'classnames';
import { hasPermissionPage } from '@hooks/hasPermissionPage';
import { useCallback } from 'react';
import { loading } from '@actions/commonActions';
import { logout } from '@actions/authActions';
import { environment } from '@env';

export const Header = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const path = pathname.includes('letters') ? `${pathname}` : 'letters';

  const isLoggedIn = useSelector<MgState, boolean>(({ auth }) => auth.isLoggedIn);
  const currentUser = useSelector(currentUserSelector);

  const hasChangelog = hasPermissionPage([PagePermission.Changelog], [PermissionActions.View]);
  const hasLetters = hasPermissionPage([PagePermission.Letters], [PermissionActions.View]);

  let handleLogoutClick;

  if (environment.auth0Enabled) {
    handleLogoutClick = useCallback(() => {
      dispatch(loading(true, 'app'));
      dispatch(logout());
      navigate(`${Paths.AUTH}/${AuthPaths.LOGOUT_REDIRECT}`);
    }, [dispatch]);
  } else {
    handleLogoutClick = useCallback(() => {
      dispatch(logout());
      localStorage.clear();
      navigate(`${Paths.AUTH}/${AuthPaths.TEST_LOGIN}`);
    }, [dispatch]);
  }

  return (
    <div className="main-header">
      <div className="header-logo">
        {hasLetters ? (
          <Link to={path}>
            <LogoMG />
          </Link>
        ) : (
          <LogoMG />
        )}
        {hasChangelog && (
          <NavLink
            className={({ isActive }) =>
              cx({ 'changelog-link active': isActive, 'changelog-link': !isActive })
            }
            to={Paths.CHANGELOG}
          >
            Changelog
          </NavLink>
        )}
      </div>
      <div className="navbar-menu">{isLoggedIn && <NavigationComponent />}</div>
      <div className="general-menu-box">
        <div className="menu-box">
          <NavigationDashboard />
          {isLoggedIn ? (
            <Avatar
              alt="Itechart employee"
              src={getUserImageLink(currentUser?.id)}
              className="avatar"
            >
              {getUserFullNameInitials(currentUser)}
            </Avatar>
          ) : (
            ''
          )}
        </div>
        <div className="logout-box">
          {isLoggedIn ? (
            <Tooltip title={translate('logout')} arrow>
              <Button
                data-testid={'logout-button'}
                className="logout-button"
                size="medium"
                onClick={handleLogoutClick}
              >
                <LogoutIcon />
              </Button>
            </Tooltip>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
};
